<template>
  <div>
    <load-profile></load-profile>
    <!-- Table Container Card -->
    <b-card>
      <validation-observer ref="editForm" #default="{ invalid }">
        <!-- form -->
        <n-form-confirmation
          key="editForm"
          @submit="submit"
          :form="$refs.editForm"
          :disabled="invalid"
        >
          <n-input :fields="fields" v-model="data" :initValue="initData">
            <template #abilities>
              <permission-table
                :loading="permissionLoading"
                :items="permissions"
                v-model="data.abilities"
              ></permission-table>
            </template>
          </n-input>
          <b-row>
            <b-col cols="12" class="text-right">
              <n-button-loading
                type="submit"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-1 mr-1"
                :loading="loading"
                :disabled="invalid"
                v-if="$can('update', 'role-permission')"
              >
                {{ $t('button.saveChanges') }}
              </n-button-loading>
              <n-button-loading
                type="button"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-secondary"
                :loading="loading"
                class="mt-1"
                @submit="back"
              >
                {{ $t('button.back') }}
              </n-button-loading>
            </b-col>
          </b-row>
        </n-form-confirmation>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardText,
  BLink,
  BFormRadioGroup,
} from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import Ripple from 'vue-ripple-directive'
import NButtonLoading from '@/components/NButtonLoading'
import NFormConfirmation from '@/components/NFormConfirmation'
import NInput from '@/components/NInput'
import formInput from './formInput'
import PermissionTable from './PermissionTable.vue'

const RoleRepository = Repository.get('role')

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardText,
    BLink,
    BFormRadioGroup,
    NButtonLoading,
    NFormConfirmation,
    NInput,
    PermissionTable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        name: null,
        description: null,
        abilities: [],
        isEnable: 1,
      },
      initData: {},
      permissions: [],
      loading: false,
      permissionLoading: false,
    }
  },
  mounted() {
    this.show()
  },
  methods: {
    show() {
      ;(this.permissionLoading = true),
        RoleRepository.show(this.$route.params.id)
          .then((response) => {
            this.initData = {
              ...response.data.data,
            }

            this.data.abilities = [...this.initData.abilities]
            this.permissions = [...this.initData.abilities]
          })
          .catch()
          .then(() => {
            this.permissionLoading = false
          })
    },
    submit() {
      this.$refs.editForm.validate().then((success) => {
        if (success) {
          this.loading = true
          RoleRepository.update(this.$route.params.id, this.data)
            .then((response) => {
              this.$router.push({
                name: 'view-role-permission',
                params: { id: response.data.data.id },
              })
            })
            .catch((error) => {
              if (error.response?.status == 422) {
                this.$refs.editForm.setErrors(error.response?.data?.message)
              }
            })
            .then(() => {
              this.loading = false
            })
        }
      })
    },
    back() {
      this.$router.back()
    },
  },
  setup() {
    const fields = [...formInput]
    return { fields }
  },
}
</script>
